module.exports = __webpack_public_path__ + "static/media/OverviewBG@2x.874deeec.png";